import { cn } from '@shared/lib/utils'

interface FieldLabelProps {
  children: React.ReactNode
  required?: boolean
  className?: string
}

export function FieldLabel({ children, required, className }: FieldLabelProps) {
  return (
    <label className={cn('text-sm font-medium text-client-neutral-950', className)}>
      {children}
      {required ? <span className="text-destructive">*</span> : null}
    </label>
  )
}
